module.exports = __webpack_public_path__ + "img/iconXiTongGongYingShangLieBiao.d8575b94.svg";